import './index.css';

const AirportInfo: React.FC = () => {
  return (
    <table>
      <tbody>
        <tr>
          <td>
            <div className="square first-lax">-</div>
            <div className="square second-lax">-</div>
          </td>
          <td>
            <div className="company-name">LAX</div>
          </td>

          <td>
            <div className="square first-cvg">-</div>
            <div className="square second-cvg">-</div>
          </td>
          <td>
            <div className="company-name">CVG</div>
          </td>

          <td>
            <div className="square first-mia">-</div>
            <div className="square second-mia">-</div>
          </td>
          <td>
            <div className="company-name">MIA</div>
          </td>

          <td>
            <div className="square first-dfw">-</div>
            <div className="square second-dfw">-</div>
          </td>
          <td>
            <div className="company-name">DFW</div>
          </td>
        </tr>
      </tbody>
    </table>
    );
};

export default AirportInfo;
